module.exports = __webpack_public_path__ + "static/media/Sanluis.3717c451.svg";